import { render, staticRenderFns } from "./NotificationsManager.vue?vue&type=template&id=5695de48"
import script from "./NotificationsManager.vue?vue&type=script&lang=js"
export * from "./NotificationsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports